import { createBrowserHistory } from 'history';

declare const APP_PATH: string;

export const history = createBrowserHistory({
  basename: APP_PATH,
});
